import type { CpuWaterfall } from './cpuWaterfall';

const COLOURS = ['#6cddcf', '#f0c36d', '#b69af3', '#e89ebc', '#81bafa', '#9ddd91', '#ffab83', '#89d8f2'];

export function channelColour(identity: string): string {
  if (identity === 'unattributed') return '#a8b1bb';
  if (identity === 'other-processes') return '#879ba9';
  let hash = 2166136261;
  for (const character of identity.toLowerCase()) hash = Math.imul(hash ^ character.charCodeAt(0), 16777619);
  return COLOURS[(hash >>> 0) % COLOURS.length];
}

export function orderedWaterfall(model: CpuWaterfall | null, previous: readonly string[]): CpuWaterfall | null {
  if (!model) return null;
  const rank = new Map(previous.map((identity, index) => [identity, index]));
  return { ...model, channels: [...model.channels].sort((left, right) => {
    const leftGroup = left.unattributed ? 2 : left.other ? 1 : 0;
    const rightGroup = right.unattributed ? 2 : right.other ? 1 : 0;
    return leftGroup - rightGroup || (rank.get(left.id) ?? previous.length) - (rank.get(right.id) ?? previous.length);
  }) };
}